import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { useForkRef } from '@mui/material/utils';
import { WrapperVariantContext } from './WrapperVariantContext';
import PickersPopper from '../PickersPopper';
function DesktopWrapper(props) {
  var children = props.children,
    DateInputProps = props.DateInputProps,
    KeyboardDateInputComponent = props.KeyboardDateInputComponent,
    onDismiss = props.onDismiss,
    open = props.open,
    PopperProps = props.PopperProps,
    PaperProps = props.PaperProps,
    TransitionComponent = props.TransitionComponent,
    onClear = props.onClear,
    clearText = props.clearText,
    clearable = props.clearable;
  var ownInputRef = React.useRef(null);
  var containerRef = React.useRef(null);
  var inputRef = useForkRef(DateInputProps.inputRef, ownInputRef);

  // get keyboard control from Input
  React.useEffect(function () {
    if (open) {
      setTimeout(function () {
        var _containerRef$current;
        (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 || _containerRef$current.focus();
      }, 0);
    }
  }, [open]);
  return /*#__PURE__*/React.createElement(WrapperVariantContext.Provider, {
    value: "desktop"
  }, /*#__PURE__*/React.createElement(KeyboardDateInputComponent, _extends({}, DateInputProps, {
    inputRef: inputRef
  })), /*#__PURE__*/React.createElement(PickersPopper, {
    role: "dialog",
    open: open,
    containerRef: containerRef,
    anchorEl: ownInputRef.current,
    TransitionComponent: TransitionComponent,
    PopperProps: PopperProps,
    PaperProps: PaperProps,
    onClose: onDismiss,
    onClear: onClear,
    clearText: clearText,
    clearable: clearable
  }, children));
}
export default DesktopWrapper;